<template>
	<div class="order-search-body">
		<div class="filters-box-row" style="display: flex; align-item: center;position: relative;">
			<div class="filters-container">
				<div class="input-box">
					<el-radio-group v-model="cashOutStatus" @change="changeStatus(cashOutStatus)">
						<el-radio-button :label="1">待审核</el-radio-button>
						<el-radio-button :label="2">待打款</el-radio-button>
						<el-radio-button :label="3">已打款</el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div style="position: absolute;right: 20px;">
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="listExport">
					<div></div>
					导出
				</el-button>
			</div>
		</div>
		<div class="filters-box-row">
			<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
			</el-button> -->
			<div class="filters-container">
				<div class="input-box time-wrap">
					<el-select v-model="dateType" class="select-input" size='small'>
						<el-option :value="0" label="申请时间"></el-option>
						<el-option :value="1" label="审核时间"></el-option>
						<el-option :value="2" label="到账时间"></el-option>
					</el-select>
					<el-date-picker
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>员工名称：</span>
					<el-input
						class="search-input"
						v-model="staff"
						placeholder="请输入员工姓名"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3" v-if="cashOutStatus !== 3">
			<el-button size="small" type="primary" v-if="cashOutStatus === 1 && AuthorityList['11_0004_0002_00']" class="btn fx-btn" style="margin-left: 0px" @click="muitlSet(2)">批量同意</el-button>
			<el-button size="small" type="primary" v-if="cashOutStatus === 1 && AuthorityList['11_0004_0002_00']" class="btn fx-btn" @click="muitlSet(0)">批量拒绝</el-button>
			<el-button size="small" type="primary" v-if="cashOutStatus === 2 && AuthorityList['11_0004_0002_00']" class="btn fx-btn" style="margin-left: 0px" @click="muitlSet(3)">批量标记打款</el-button>
		</div>
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="450px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-percontent">
					<div>共选择{{ids.length}}条数据</div>
					<div>您确认要进行“{{batchType}}”吗？</div>
				</div>
				<div style="text-align:center">
					<el-button class="btn" size="small" type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="multiSave">保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		batchSelectData: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		orderKey: String,
		orderBy: String
	},
	watch: {

	},
	data () {
		return {
			collapse: true,
			dialogVisible: false,
			cashOutStatus: 1,
			dateType: 0,
			dateValue: [],
			params: {},
			batchType: '',
			staff: '',
			batchTypeNum: -1,
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('withDrawalSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('withDrawalSelect'))
			this.staff = data.staff
			this.dateType = data.dateType
			this.dateValue = data.dateValue
			this.cashOutStatus = data.cashOutStatus
		}
		// this.getBigCategory()
	},
	methods: {
		listExport () {
			let params = this.params
			params.orderKey = this.orderKey
			params.orderBy = this.orderBy
			params.staff = this.staff
			params.dateType = this.dateType
			params.cashOutStatus = this.cashOutStatus
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/commission/cashout/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let name = ''
			if (this.dateValue.length > 0) {
				name = this.dateValue[0] + '-' + this.dateValue[1] + '提现审核结果.xls'
			} else {
				name = '提现审核结果.xls'
			}
			name = name.replace(/:/g, '：')
			a.download = name
			a.href = blobUrl
			a.click()
		},
		changeStatus (val) {
			this.cashOutStatus = val
			this.search()
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.dateValue = []
			}
			if (!(this.dateValue === null || this.dateValue.length === 0)) {
				var begintime = this.dateValue[0]
				var endtime = this.dateValue[1]
				// 判断时间跨度是否大于6个月
				var arr1 = begintime.split('-')
				var arr2 = endtime.split('-')
				arr1[1] = parseInt(arr1[1])
				arr1[2] = parseInt(arr1[2])
				arr2[1] = parseInt(arr2[1])
				arr2[2] = parseInt(arr2[2])
				var flag = true
				// if (arr1[0] === arr2[0]) { // 同年
				// 	if (arr2[1] - arr1[1] > 6) { // 月间隔超过6个月
				// 		flag = false
				// 	} else if (arr2[1] - arr1[1] === 6) { // 月相隔6个月，比较日
				// 		if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
				// 			flag = false
				// 		}
				// 	}
				// } else { // 不同年
				if (arr2[0] - arr1[0] > 1) {
					flag = false
				} else if (arr2[0] - arr1[0] === 1) {
					if (arr1[1] < arr2[1]) { // 月相隔大于12个月
						flag = false
					} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
						if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
							flag = false
						}
					}
				}
				// }
				if (!flag) {
					this.$message.error('时间范围不得超过12个月！')
					return false
				}
				return true
			} else {
				return true
			}
		},
		muitlSet (val) {
			if (this.ids.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			this.batchTypeNum = val
			switch (val) {
			case 2:
				this.batchType = '批量同意'
				break
			case 0:
				this.batchType = '批量拒绝'
				break
			case 3:
				this.batchType = '批量标记打款'
				break
			}
			this.dialogVisible = true
		},
		multiSave () {
			// if (!this.percentValue) {
			// 	this.$message.error('提成方式不可为空！')
			// 	return false
			// }
			let params = {
				cashOutStatus: this.batchTypeNum,
				cashOutIds: this.ids.join(',')
			}
			let loggerText = ''
			this.batchSelectData.forEach(item => {
				let text = `员工名称【${item.staff}】提现编号【${item.cashoutcode}】提现金额【￥${item.cashoutmoney}】${this.batchType}`
				loggerText += text
			})
			let changeData = {
				pre: { cashOutData: {} },
				cur: { cashOutData: { text: loggerText } }
			}
			const logger = this.$fxLogger.createInfo('results.withdrawalReview.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/cashout/cashoutstatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.dialogVisible = false
					this.$message.success('成功处理' + this.ids.length + '条数据')
					this.$emit('modifySuc')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		close () {
			this.dialogVisible = false
		},
		search () {
			if (this.checkTime()) {
				this.$emit('handleSearch', { staff: this.staff, dateValue: this.dateValue, dateType: this.dateType, cashOutStatus: this.cashOutStatus })
			}
		},
		clear () {
			this.cashOutStatus = 1
			this.dateType = 0
			this.staff = ''
			this.dateValue = []
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	padding: 10px 0 0 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	text-align: left
	.select-input {
		width: 100px;
		margin-right: 5px
	}
	.time-wrap {
		display: flex;
		align-items: center;
	}
	.input-title {
		display: inline-block;
		text-indent: 1em
	}
	&.filters-box-row2 {
		padding-top: 0;
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 155px
		}
		.filter-input {
			width: 155px
		}
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
			display: flex;
			width: 100px;
			height: 32px;
			justify-content center;
			align-items center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.dialog-percontent {
		display: flex;
		flex-flow: column;
		align-items: start;
    margin: 20px 50px 30px;
    line-height: 20px;
		.per-select {
			width: 135px;
			margin: 0 10px
		}
		.per-money {
			position: relative
			.per-tag {
				position: absolute
				left: 1px
				top: 1px
				bottom: 1px;
				width: 40px;
				z-index: 9;
				display: flex;
				border-top-left-radius: 4px;
				border-bottom-left-radius: 4px;
				align-items: center;
				justify-content: center;
				background-color: #eee;
			}
			.per-input {
				width: 150px
				input {
					text-indent: 35px
				}
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
